import React, { useEffect, useState } from 'react';
import { setupWorker } from 'msw';

export const ApiMocks = ({ children }) => {
  const [loadedMocks, setLoadedMocks] = useState(false);
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      import('new/apiMocks/handlers').then((res) => {
        const handlers = res.default;
        const server = setupWorker(...handlers);
        if (handlers?.length) {
          server
            .start({
              onUnhandledRequest: 'bypass', // Let unhandled requests pass through to the real API
              quiet: false, // Set to true to suppress MSW console logs
            })
            .then(() => setLoadedMocks(true));
        } else {
          try {
            server.stop();
          } catch (ignore) {}
          setLoadedMocks(true);
        }
      });
    } else {
      setLoadedMocks(true);
    }
  }, []);
  if (loadedMocks) return children;
  return null;
};
